document.addEventListener('DOMContentLoaded', () => {
  const banners = document.querySelectorAll('[data-homepage-banner]');

  banners.forEach((banner) => {
    const slides = Array.from(
      banner.querySelectorAll('.homepage-banner__slide')
    );
    const slideContents = Array.from(
      banner.querySelectorAll('.homepage-banner__slide-content')
    );
    const dots = Array.from(
      banner.querySelectorAll('[data-slide-target]')
    );

    let current = 0;
    const autoplay =
      banner.dataset.autoplay === 'true' ||
      banner.dataset.autoplay === '1';
    const delaySeconds = Number(banner.dataset.autoplayDelay || 5);
    const delay = delaySeconds * 1000;
    let timer = null;

    const goTo = (index) => {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === current);
      });
      slideContents.forEach((content, i) => {
        content.classList.toggle('is-active', i === current);
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current);
      });
    };

    if (slides.length && dots.length) {
      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const target = Number(dot.dataset.slideTarget || 0);
          goTo(target);
          if (autoplay && timer) {
            clearInterval(timer);
            timer = setInterval(() => goTo(current + 1), delay);
          }
        });
      });

      if (autoplay && slides.length > 1) {
        timer = setInterval(() => goTo(current + 1), delay);
      }
    }

    const input = banner.querySelector('[data-suggestions-toggle]');
    const panel = banner.querySelector('[data-suggestions-panel]');
    if (input && panel) {
      const wrapper =
        input.closest('.homepage-banner__search-wrapper') || banner;

      const show = () => {
        panel.removeAttribute('hidden');
      };
      const hide = () => {
        panel.setAttribute('hidden', '');
      };

      input.addEventListener('input', () => {
        if (input.value.trim()) {
          show();
        } else {
          hide();
        }
      });

      input.addEventListener('focus', () => {
        if (input.value.trim()) show();
      });

      panel.addEventListener('mousedown', (e) => e.preventDefault());

      document.addEventListener('click', (e) => {
        if (!wrapper.contains(e.target)) {
          hide();
        }
      });

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          hide();
          input.blur();
        }
      });
    }
  });

  const landingBanner = banners[0];
  if (!landingBanner) return;

  const getThreshold = () =>
    landingBanner.offsetTop + landingBanner.offsetHeight;

  const updateNavSearch = () => {
    const navSearch = document.getElementById('coveo-search-wrapper');
    if (!navSearch) return;

    const threshold = getThreshold();

    /* Keep header search expanded while the hero is visible; collapse after scroll. */
    if (window.scrollY >= threshold) {
      navSearch.classList.add('nav-search--icon-only');
    } else {
      navSearch.classList.remove('nav-search--icon-only');
    }
  };

  updateNavSearch();
  window.addEventListener('scroll', updateNavSearch);
  window.addEventListener('resize', updateNavSearch);

  document.querySelectorAll('[data-homepage-banner-scroll]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const banner = btn.closest('[data-homepage-banner]');
      if (!banner) return;
      const next = banner.nextElementSibling;
      if (next && typeof next.scrollIntoView === 'function') {
        next.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      const top = banner.offsetTop + banner.offsetHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });
});
